module.exports = __webpack_public_path__ + "assets_1789460829583/img/logo.a6acaf61.png";